import { useMutation } from '@tanstack/react-query';
import type { SubmitCredentialingRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';
import type { SubmitCredentialing200 } from '@lotushealth/lotushealth_js_sdk/schemas';

import { submitCredentialingApi } from '../api/submitCredentialing.js';
import { clinicianApplicationKeys } from './keys.js';

export interface SubmitCredentialingVariables {
  data: SubmitCredentialingRequestT;
}

export function useSubmitCredentialingMutation() {
  return useMutation<SubmitCredentialing200, Error, SubmitCredentialingVariables>({
    mutationKey: [...clinicianApplicationKeys.all, 'submitCredentialing'],
    mutationFn: async ({ data }) => {
      return await submitCredentialingApi(data);
    },
  });
}
